import React from "react";

import { StructuredTextRenderer } from "../StructuredTextRenderer";
import { Button } from "../Button";

import remoteAssetUrl from "../../lib/remote-asset-url";
import calculateFileSizeString from "../../lib/helper/calculateFileSizeString";

function DownloadElement({
    id,
    label,
    url,
    linkState,
    isFileUrl,
    isExternalUrl,
    externalDownloadLink,
    fileSize,
    format,
    showFileSize
}) {
    const fileSizeString = calculateFileSizeString(fileSize, "kb");
    const linkLabel = `${label}${
        showFileSize && fileSizeString ? ` (${fileSizeString})` : ""
    }`;
    return (
        <>
            {externalDownloadLink?.value && url.length === 0 ? (
                <StructuredTextRenderer
                    data={externalDownloadLink}
                    contentElementType={"DownloadElement"}
                    plainLink
                    noContainer
                />
            ) : (
                <Button
                    type="primary"
                    renderAs="link"
                    key={id}
                    state={linkState}
                    target={isFileUrl || isExternalUrl ? "_blank" : undefined}
                    to={url}
                    icon={format === "zip" ? "zip" : "file"}
                    iconPosition="left"
                >
                    {linkLabel}
                </Button>
            )}
        </>
    );
}

export { DownloadElement };
